import React, {useRef} from "react";
import {useStateValue} from "../App";

export const YearSwitcher = React.memo(
    ({
         year,
         yearFunction
     }) => {
        const intYear = parseInt(year);

        return (
            <>
                <div onClick={() => yearFunction(intYear<2023?intYear:intYear-1)} className={'yearSwitcher dec' + (intYear<2023? ' disabled':'')}>
                    <i className="fa-regular fa-arrow-left"></i></div>
                <div className={'yearSwitcher current'}>{intYear} en {intYear + 1}</div>
                <div onClick={() => yearFunction(intYear+1)} className={'yearSwitcher inc'}><i
                    className="fa-regular fa-arrow-right"></i></div>
            </>
        );
    }
);
